import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=18e40962&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18e40962')) {
      api.createRecord('18e40962', component.options)
    } else {
      api.reload('18e40962', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=18e40962&", function () {
      api.rerender('18e40962', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2We82f2iGvkGZ/JS/offershelp.vue"
export default component.exports